import client from '@/http'
import dayjs from 'dayjs'

const loadAll = (context) => {
  client.get(
    '/tables'
  ).then(
    (res) => {
      context.commit('SET_TABLES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const load = (context, tableId) => {
  client.get(
    `/tables/${tableId}`
  ).then(
    (res) => {
      context.commit('SET_TABLE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const loadForAdmin = (context, params) => {
  client.get(
    `/tables/${params.id}`
  ).then(
    (res) => {
      context.commit('SET_TABLE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, name) => {
  if (context.state.table) {
    let data = {
      id: context.state.table.id,
      name: name,
      column_ids: context.state.table.column_ids
    }
    client.put(
      `/tables/${context.state.table.id}`, data
    ).then(
      () => {
        context.commit('UPDATE', data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      '/tables', { name: name }
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const remove = (context, tableId) => {
  client.delete(
    `/tables/${tableId}`
  ).then(
    () => {
      context.commit('REMOVE', tableId)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const submitImport = (context, params) => {
  client.post(
    'tables/import', params
  ).then(
    () => {}
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const submitExport = (context, params) => {
  client.get(`tables/export/${params.table.id}/${params.bundle.id}`, {
    responseType: 'blob'
  }).then(
    res => {
      const timestamp = dayjs().format('DD-MM-YYYY_HH-mm-ss')
      const filename = `${params.bundle.name}-${params.table.name}-${timestamp}.xlsx`
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    }
  )
}

const combineDatasets = (context, params) => {
  client.post(
    'datasets/bulk-create', {
      table_id: params.tableId,
      bundle_id: params.bundleId,
      value_ids: params.selection
    }
  ).then(
    () => {}
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const editCombinedDatasets = (context, params) => {
  client.post(
    'datasets/bulk-edit', params
  ).then(
    () => {
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  save,
  load,
  remove,
  loadAll,
  loadForAdmin,
  submitImport,
  submitExport,
  combineDatasets,
  editCombinedDatasets
}
